import { IInvoiceRecord } from 'components/InvoiceSectionOfBillingTab/InvoiceSectionOfBillingTab.types';
import { IbillingMethod } from './global';

export interface IStorageBillingInvoices {
  storageInvoiceId: number;
  invoiceNumber: string;
  amount: number;
  exchangeRate: number;
  currency: string;
  currencyName: string;
  invoiceUrl?: string;
  warehouseLocation: IWarehouseLocation;
  billedTo: IBilledTo;
  month: string;
  organizationInfo: IorganizationData;
  paymentType: string;
  billingMethod: IbillingMethodData;
  selectedPaymentMethod?: string;
  proofOfPaymentUrl?: string;
  invoiceRecords: IInvoiceRecord;
}

export interface IWarehouseLocation {
  country: string;
  countryCode: string;
}

export interface IBilledTo {
  companyName: string;
  document: string;
  country: string;
  countryCode: string;
  address?: string;
  fantasyName?: string;
  colony?: string;
  city?: string;
  state?: string;
  zipCode?: string;
  additionalReferences?: string;
  additionalBillingData?: string;
  email?: string;
  phone?: string;
  phoneCode?: string;
  taxSituation?: string;
  taxUse?: string;
  taxSituationDocUrl?: string;
}

export interface IorganizationData {
  organizationId: number;
  organizationName: string;
  organizationBusinessName: string;
}

export interface IbillingMethodData {
  billingMethodId: number;
  billingMethodName: string;
  billingCountry: string;
  beneficiary: string;
  taxManagementName: string;
  billingProvider: string;
}

export interface ISellerBillingEntity {
  id: number;
  name: string;
  billingMethod: IbillingMethod;
  entityCountryCode: string;
}

export enum INVOICE_STATUS {
  LOADED = 'loaded',
  PENDING = 'pending'
}

export enum PAYMENT_METHODS {
  CARD = 'tarjeta',
  TRANSFER = 'transferencia',
  CREDIT_CARD = 'Tarjeta de crédito'
}

export type IStorageBillingInvoicesGroupedByMonth = Record<string, IStorageBillingInvoices[]>;
